import moment from 'moment';
import { checkForLocationConflict, OnItemResizeArgs } from '@modules/timetable';

export const onItemResize = async ({ itemID, time, edge, timelineItems }: OnItemResizeArgs) => {
  const itemIndex = timelineItems.findIndex((timelineItem) => timelineItem.id === itemID);
  const item = timelineItems[itemIndex];
  const newTime = moment(time);

  const isTargetValid = await checkForLocationConflict({
    timelineItems,
    item,
    endTime: edge === 'right' ? newTime : item.endTime,
    startTime: edge === 'left' ? newTime : item.startTime,
  });

  if (isTargetValid) {
    if (edge === 'left') {
      item.setStartTime(newTime);
    } else {
      item.setEndTime(newTime);
    }
  }
};
